<template>
	
<div class="contact">

	<div class="contact-title">{{ section.treatment.more.contact.title }}</div>
	<div class="contact-text">{{ section.treatment.more.contact.text }}</div>

</div>

</template>

<script>

export default {

	props: ['section', 'treatment'],

}

</script>

<style scoped>

.contact {
	background-color: #FFEDC8;
	padding: 32px 32px 32px 110px;
	border-radius: 17px;
	margin-bottom: 32px;
	background-image: url(~@/assets/aid/improve/treatment/more/contact.svg);
	background-position: 32px 28px;
	background-repeat: no-repeat;
}

.contact-title {
	color: #343434;
	font-size: 16px;
	margin-bottom: 8px;
	font-weight: 600;
}

.contact-text {
	color: #343434;
	font-size: 16px;
	font-weight: 300;
}

</style>